import * as Linking from 'expo-linking';
import React from 'react';

import { Text } from '~/components/text';
import { FormattedMessage, useIntl } from '~/contexts/intl';

export type Props = {
    messageId: string;
};

export const Info: React.FC<Props> = ({ messageId }) => {
    const { formatMessage } = useIntl();

    return (
        <FormattedMessage
            id={messageId}
            values={{
                terms: (value: string) => (
                    <Text.SMALL_BUTTON_LABEL
                        style={{ textDecorationLine: 'underline' }}
                        onPress={async () => {
                            await Linking.openURL(formatMessage('auth-accept-terms.terms'));
                        }}
                    >
                        {value}
                    </Text.SMALL_BUTTON_LABEL>
                ),
                privacy: (value: string) => (
                    <Text.SMALL_BUTTON_LABEL
                        style={{ textDecorationLine: 'underline' }}
                        onPress={async () => {
                            await Linking.openURL(formatMessage('auth-accept-terms.privacy'));
                        }}
                    >
                        {value}
                    </Text.SMALL_BUTTON_LABEL>
                )
            }}
        />
    );
};
